export default {"src":"/_next/static/media/HAL.7bb42114.svg","height":18,"width":18};